import _ from "lodash";
import { EMPTY_CELL } from "../constants";

const getDropdownCellProps = ({ node, cellConfig, customConfig }) => {
  const { styles } = cellConfig || {};
  const { property, showEmptyCellAsFallback = false } = customConfig || {};

  const value = _.get(node, property);

  if ((_.isArray(value) && _.isEmpty(value)) || !value) {
    if (showEmptyCellAsFallback) {
      return { ...EMPTY_CELL, styles };
    }
  }

  const options = _.map(value, ({ id, name, label }) => ({
    id,
    label: label || name,
  }));

  return {
    ...cellConfig,
    validInputs: {
      options,
    },
    value: options,
  };
};

export default getDropdownCellProps;
